import { useSelector } from "react-redux";
import { Routes, Route } from "react-router-dom";

import Anonymouslayout from "../Components/Anonymous/layout";
import Userlayout from "../Components/User/Layout/Userlayout";

import Login from "../Pages/Auth/Login";
import Signup from "../Pages/Auth/Signup";
import ForgotPassword from "../Pages/Auth/ForgotPassword";
import ResetPassword from "../Pages/Auth/ResetPassword";

import ActiveSessions from "../Pages/ActiveSessions";
import ContactUs from "../Pages/ContactUs";
import Dashboard from "../Pages/Dashboard";
import Edit from "../Pages/Edit";
import History from "../Pages/History";
import Profile from "../Pages/Profile";
import RecentReservations from "../Pages/RecentReservations";
import ReservationPortal from "../Pages/ReservationPortal";
import Sessions from "../Pages/Session/Sessions";
import SubscriptionPlan from "../Pages/SubscriptionPlan";
import SuccessPayment from "../Pages/SuccessPayment";
import UserManager from "../Pages/UserManager";
import UserList from "../Pages/UserList";
import Maintenance from "../Pages/Maintenance";

export default function AppRoutes() {
  const auth = useSelector((state) => state.auth);
  return (
    <>
    <Routes>
      {auth.accessToken ? ( // User is logged in (or at least has an access token)
        <Route path="/" element={<Userlayout />}>
          { (auth.userDeatils.is_admin || auth.userDeatils.is_staff) && ( // local state indicates this user is an admin
            // NOTE: ANY user can forge this to be True, so make sure to verify user admin status in the API!
            <Route path="admin">
              <Route exact path="recent-reservations" element={<RecentReservations />}></Route>
              <Route exact path="active-sessions" element={<ActiveSessions />}></Route>
              <Route exact path="users" element={<UserManager />}></Route>
              <Route exact path="maintenance" element={<Maintenance />}></Route>
              <Route exact path="user-list" element={<UserList />}></Route>
            </Route>
          )}
          <Route index path="" element={<Dashboard />}></Route>
          <Route exact path="dashboard" element={<Dashboard />}></Route>
          <Route exact path="edit" element={<Edit />}></Route>
          <Route exact path="profile" element={<Profile />}></Route>
          <Route exact path="sessions" element={<Sessions />}></Route>
          {/* '/session/<id>/<role>' is a template in django */}
          <Route exact path="reservation/:reservation_id" element={<ReservationPortal />}></Route>
          <Route exact path="subscription" element={<SubscriptionPlan />}></Route>
          <Route exact path="history" element={<History />}></Route>
          <Route exact path="payment/success" element={<SuccessPayment />}></Route>
          <Route exact path="contact" element={<ContactUs />}></Route>

          {/* Fallback */}
          <Route exact path="*" element={<Dashboard />}></Route>
        </Route>
      ) : ( // Anonymous (ie not logged in) user
        <Route path="/" element={<Anonymouslayout />}>
          <Route exact path="reservation/:reservation_id" element={<ReservationPortal />}></Route>

          <Route path="" element={<Login />}></Route>
          <Route path="login" element={<Login />}></Route>
          <Route path="signup" element={<Signup />}></Route>
          <Route path="forgot_password" element={<ForgotPassword />}></Route>
          <Route path="reset_password/:uid/:token" element={<ResetPassword />}></Route>

          <Route path="*" element={<Login />}></Route>
        </Route>
      )}
    </Routes>
    </>
  )
}
